import {
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  HttpParams,
  type HttpRequest
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class PublicPinboardInterceptor implements HttpInterceptor {
  private readonly window: Window | null = inject(DOCUMENT).defaultView;

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentUrl = this.window?.location.href;
    if (currentUrl?.includes('public/pinboard') && /widget\/v\d+\/widget/.exec(req.url)) {
      const splitUrl = currentUrl.split('/');
      return next.handle(
        req.clone({
          params: (req.params ?? new HttpParams()).set('pinboardId', splitUrl[splitUrl.length - 1])
        })
      );
    }

    return next.handle(req);
  }
}
